import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiTrendingUp, FiLayers, FiTarget, FiZap } = FiIcons;

const Expertise = () => {
  const areas = [
    {
      icon: FiTrendingUp,
      title: "Strategic Architecture",
      description: "Multi-dimensional framework design for complex organizational challenges"
    },
    {
      icon: FiLayers,
      title: "Systems Integration",
      description: "Harmonizing disparate elements into cohesive, high-performance ecosystems"
    },
    {
      icon: FiTarget,
      title: "Leadership Synthesis",
      description: "Executive development through advanced cognitive and behavioral methodologies"
    },
    {
      icon: FiZap,
      title: "Innovation Catalysis",
      description: "Accelerating breakthrough thinking through structured creative processes"
    }
  ];

  return (
    <section id="expertise" className="py-24">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-serif text-slate-100 mb-6">
            Areas of Expertise
          </h2>
          <div className="w-16 h-px bg-amber-400 mx-auto mb-8" />
          <p className="text-xl text-slate-300 max-w-3xl mx-auto leading-relaxed">
            Our practice encompasses four core disciplines, each refined through years 
            of application across diverse organizational contexts.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8">
          {areas.map((area, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              whileHover={{ y: -5 }}
              className="bg-slate-800/50 backdrop-blur-sm border border-slate-700/50 rounded-lg p-8 hover:border-amber-400/30 transition-all duration-300"
            >
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-amber-400/20 rounded-lg flex items-center justify-center">
                    <SafeIcon icon={area.icon} className="text-amber-400 text-xl" />
                  </div>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-slate-100 mb-3">
                    {area.title}
                  </h3>
                  <p className="text-slate-300 leading-relaxed">
                    {area.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Expertise;